module.exports = __webpack_public_path__ + "assets/img/rightNav.ee02ef67.png";